import React from 'react'
import '../style/style.css'
import {motion} from 'framer-motion'

export default function About() {
    return (
    <motion.div 
      initial={{opacity:0, y:"-100%"}} 
      animate={{opacity:1, y:0}} 
      exit={{opacity:0, y:"-100%"}} 
      transition={{type:"spring"}}
      className="bg col-lg-9 col-md-9 col-sm-9 col-xs-12">

      <div className="container" id="about">
        <h1>Hello, I'm Ritika</h1>
        <h2>I'm a FrontEnd Developer from Jharkhand, India.</h2> <br/><br/>
        <p>I'm a CSE undergrad at Ramgarh engineering college.
           I'm a hard-working, adaptable, dedicated front-end developer
           with zeal and enthusiasm for learning and determination to
           learn something better every day. I always try to become a 
           better version of myself with every project I work on. 
           My main area of expertise are HTML, CSS, JavaScript and
           React but I know PHP, Node, SQL, Mongo and Express.</p><br/>

      <center>
        <div className="d-inline-block">
           <a href="https://m.facebook.com/ritika.dey.3785373" target="blank" className="fa fa-facebook"/>
           <a href="https://www.instagram.com/_ritika_dey/" target="blank" className="fa fa-instagram"/>
           <a href="https://www.linkedin.com/in/ritika-dey/" target="blank" className="fa fa-linkedin"/>
           <a href="https://github.com/Ritika-dey" target="blank" className="fa fa-github"/>
           <a href="mailto:ritikadey7890@gmail.com" target="blank" className="fa fa-envelope"/>
        </div>
      </center>
      </div>
    </motion.div>  
    )
}
